import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { OnboardingPageService } from '../../onboarding-page/onboarding-page.service';

@Component({
  selector: 'app-fleet-onboarding',
  template: require('./fleet-onboarding.component.html'),
  providers: [OnboardingPageService]
})
export class FleetOnboardingComponent implements OnInit {

  public overHeadPanelTitle = 'Fleet Onboarding';

  public mobile: string;
  public fleetType: string;
  public cityId: string;

  public name: string;
  public gstNumber: string;
  public emailsText: string;
  public modeId: string;

  public citiesList: any[] = [];
  public citiesOptions: Array<{ id: string, name: string }> = [];
  public modeOptions: Array<{ id: string, name: string }> = [
    { id: 'Auto', name: 'Auto' },
    { id: 'Car', name: 'Car' },
    { id: 'Bike', name: 'Bike' }
  ];

  mobileFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern('[0-9]{10}')
  ]);
  fleetTypeFormControl = new FormControl('', [
    Validators.required
  ]);
  nameFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern('[a-zA-Z0-9](?!.*  )[a-zA-Z0-9 &.-]{0,199}')
  ]);
  gstFormControl = new FormControl('', [
    Validators.required
  ]);
  emailsFormControl = new FormControl('', [
    Validators.required,
    this.emailsArrayValidator
  ]);

  constructor(
    private router: Router,
    private onboardingService: OnboardingPageService
  ) {}

  ngOnInit() {
    this.loadCities();
  }

  loadCities() {
    this.onboardingService.getCitiesList().subscribe(
      (resp: any) => {
        const cities = resp && resp.geolayers ? resp.geolayers : [];
        this.citiesList = cities.sort((a, b) => {
          const an = (a && a.properties && a.properties.displayName) ? a.properties.displayName : '';
          const bn = (b && b.properties && b.properties.displayName) ? b.properties.displayName : '';
          return an.localeCompare(bn);
        });
        this.citiesOptions = this.citiesList.map(item => ({ id: item.cityId, name: item.properties && item.properties.displayName || '' }));
      },
      err => {
        // swallow error; UI will show empty list
        // console.log(err);
      }
    );
  }

  emailsArrayValidator(control: FormControl) {
    if (!control || !control.value) { return { required: true }; }
    const parts = String(control.value).split(/[\,\s]+/).map(v => v.trim()).filter(v => !!v);
    if (parts.length === 0) { return { required: true }; }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const invalid = parts.find(v => !emailRegex.test(v));
    return invalid ? { emailArray: true } : null;
  }

  isFormValid() {
    return this.mobileFormControl.valid
      && this.fleetTypeFormControl.valid
      && !!this.cityId
      && this.nameFormControl.valid
      && this.gstFormControl.valid
      && this.emailsFormControl.valid
      && !!this.modeId;
  }

  startOnboarding() {
    if (!this.isFormValid()) { return; }
    // To be integrated with BE in next step
    // Example payload structure (not sent):
    // const payload = {
    //   name: this.name,
    //   gstNumber: this.gstNumber,
    //   email: String(this.emailsText).split(/[\,\s]+/).map(v => v.trim()).filter(v => !!v),
    //   modeId: this.modeId,
    //   mobile: this.mobile,
    //   fleetType: this.fleetType,
    //   cityId: this.cityId
    // };
  }

  goBack() {
    this.router.navigate(['/onboardFleet']);
  }
} 